import { defineComponent as _defineComponent } from 'vue'
import { bendPartCategoryService } from '@/services/bendPartCategory.service';
import { Customer } from '@/models/tenant';
import { BendPartCategory } from '@/models/bendPartCategory';
import { computed, onMounted, reactive, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { maxValue, minValue } from '@/utils/validation';
import { useI18n } from '@/composables/i18n';
import { helpers } from '@vuelidate/validators';
import { toastService } from '@/library-services/toast.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerBendPartCategoryConfig',
  props: {
    customer: null
  },
  setup(__props: any) {

const props = __props as {
  customer: Customer;
};



const bendPartCategory = reactive(BendPartCategory.GetEmpty());
const bendPartCategoryInitial = reactive(BendPartCategory.GetEmpty());
const isReadOnly = ref(true);
const isLoading = ref(false);
const isSubmitting = ref(false);

const { t } = useI18n();

const simpleToMaxValue = computed(() => bendPartCategory.mediumTo! - 1);
const mediumToMinValue = computed(() => bendPartCategory.simpleTo! + 1);

const validations = {
  simpleTo: {
    minValue: helpers.withMessage(
      () => t('bend_part_category.validation_error').toString(),
      minValue(1),
    ),
    maxValue: helpers.withMessage(
      () => t('bend_part_category.validation_error').toString(),
      maxValue(simpleToMaxValue),
    ),
  },
  mediumTo: {
    minValue: helpers.withMessage(
      () => t('bend_part_category.validation_error').toString(),
      minValue(mediumToMinValue),
    ),
  },
};
const v$ = useVuelidate(validations, bendPartCategory);

onMounted(async () => {
  await loadData();
});

async function loadData() {
  isLoading.value = true;
  bendPartCategoryService
    .get(props.customer.id)
    .then((bendPartCat) => {
      Object.assign(bendPartCategory, bendPartCat);
      Object.assign(bendPartCategoryInitial, bendPartCat);
    })
    .finally(() => (isLoading.value = false));
}

async function onSubmit() {
  isSubmitting.value = true;
  bendPartCategoryService
    .update(bendPartCategory)
    .then(() => {
      toastService.success('tenant.update_success');
      isReadOnly.value = true;
      Object.assign(bendPartCategoryInitial, bendPartCategory);
    })
    .finally(() => (isSubmitting.value = false));
}

function startEdit() {
  isReadOnly.value = false;
}

function cancelEdition() {
  isReadOnly.value = true;
  Object.assign(bendPartCategory, bendPartCategoryInitial);
}

const sliderValue = computed({
  get(): [number, number] {
    return [bendPartCategory.simpleTo ?? 0, bendPartCategory.mediumTo ?? 0];
  },
  set(newValue: [number, number]) {
    bendPartCategory.simpleTo = newValue[0];
    bendPartCategory.mediumTo = newValue[1];
  },
});

const tableData = computed(() => [
  {
    category: 'simple',
    bendsFrom: 0,
    bendsTo: bendPartCategory.simpleTo!,
  },
  {
    category: 'medium',
    bendsFrom: bendPartCategory.simpleTo! + 1,
    bendsTo: bendPartCategory.mediumTo!,
  },
  {
    category: 'complex',
    bendsFrom: bendPartCategory.mediumTo! + 1,
    bendsTo: '∞',
  },
]);

const validationMessage = computed(() => v$.value.$errors[0]?.$message);

return { __sfc: true,props, bendPartCategory, bendPartCategoryInitial, isReadOnly, isLoading, isSubmitting, t, simpleToMaxValue, mediumToMinValue, validations, v$, loadData, onSubmit, startEdit, cancelEdition, sliderValue, tableData, validationMessage }
}

})